import { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import 'semantic-ui-css/semantic.min.css';
import { Header, Table, Select, Button, Form, Loader } from 'semantic-ui-react';
import { useStore } from '../../app/stores/store';
import DynamicTableCSVReport from '../DynamicTable/DynamicTableCSVReport';
import DatePicker from 'react-datepicker';
import { qcperformacedata } from '../../app/models/Restoration';
import moment from 'moment';
import { toast } from 'react-toastify';

const QualityTeamTitlewisePerformace = () => {
  const { RestorationStore, PivotStore } = useStore();
  const [reportTypeValue, setReportTypeValue] = useState<string>('Report Type');
  const [tableEnable, SetTableEnable] = useState<boolean>(false);
  const [assingTitleCode, setAssignTitleCode] = useState<
    { key: string; text: string; value: string }[]
  >([]);
  const [loadData, setLoadData] = useState<qcperformacedata[]>([]);
  const [reportType, setReportType] = useState<string>('');
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const reportTypeOptions = [
    { key: 1, text: 'Title Wise', value: 'Title Wise' },
    { key: 2, text: 'Date Wise', value: 'Date Wise' },
  ];
  let reportName = '';
  const currentDate = new Date();
  const [startDate, setStartDate] = useState(() =>
    moment(currentDate).format('MM-DD-YYYY')
  );
  const [endDate, setendDate] = useState(() => {
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, '0');
    const day = String(currentDate.getDate()).padStart(2, '0');
    return `${month}-${day}-${year}`;
  });

  useEffect(() => {
    RestorationStore.getTitleCode();
    // eslint-disable-next-line
  }, []);

  const reportTypeAssign = async (_event: any, data: any) => {
    const { value } = data;
    const selected = reportTypeOptions.find((option) => option.value === value);
    if (selected) {
      setReportTypeValue(selected.value);
      setReportType(selected.value);
      setLoadData([]);
      SetTableEnable(false);
    } else {
      setReportTypeValue('Report Type');
      setReportType('');
      SetTableEnable(false);
      setLoadData([]);
    }
  };

  const titleBasedDataLoad = async (titlename: string) => {
    try {
      if (!titlename) {
        setLoadData([]);
        return;
      }
      setIsLoading(true);
      await RestorationStore.qcperformance(titlename);
      setLoadData(RestorationStore.dataqualityteamtitleperformace);
      SetTableEnable(true);
      reportName = 'Quality_Report_' + titlename;
    } catch (error) {
      toast.error('Something went wrong. Please try again!');
      SetTableEnable(false);
    } finally {
      setIsLoading(false);
    }
  };

  const dateBasedDataLoad = async () => {
    try {
      setIsLoading(true);
      await RestorationStore.performanceQualityReportbyTitle(startDate, endDate);
      setLoadData(RestorationStore.dataqualityteamtitleperformace);
      SetTableEnable(true);
      reportName = `Quality_Report_From_${startDate}_upto_${endDate}`;
    } catch (error) {
      toast.error('Something went wrong. Please try again!');
      SetTableEnable(false);
    } finally {
      setIsLoading(false);
    }
  };

  const setDate = (data: any, type: string) => {
    try {
      if (type === 'start') {
        setStartDate(moment(data).format('MM-DD-YYYY'));
      } else if (type === 'end') {
        setendDate(moment(data).format('MM-DD-YYYY'));
      }
    } catch (error) {
      toast.error('Error fetching Date');
    }
  };

  useEffect(() => {
    const loadTitleCode = RestorationStore.titleCodeData.map(
      (titleCodeList: string) => ({
        key: titleCodeList,
        text: titleCodeList,
        value: titleCodeList,
      })
    );
    setAssignTitleCode(loadTitleCode);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reportTypeValue]);

  return (
    <>
      <div className="title-wise-table">
        <Header> Quality Team Performance Report</Header>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <h4 style={{ paddingRight: '20px', paddingTop: '10px' }}>
              Report Type
            </h4>
            <Select
              placeholder="Report Type"
              filter
              selection
              search
              clearable
              options={reportTypeOptions}
              onChange={reportTypeAssign}
            />

            {reportType === 'Title Wise' && (
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <h4 style={{ paddingRight: '20px', paddingTop: '10px', paddingLeft: '20px' }}>
                  Title Code
                </h4>
                <Select
                  placeholder="Select Title code"
                  filter
                  selection
                  search
                  clearable
                  options={assingTitleCode}
                  onChange={(_event, data) =>
                    titleBasedDataLoad(data.value as string)
                  }
                />
                {loadData.length !== 0 && (
                  <div style={{ marginLeft: '5px', textAlign: 'right' }}>
                    <DynamicTableCSVReport tableData={loadData} tableName={reportName} />
                  </div>
                )}
              </div>
            )}

            {reportType === 'Date Wise' && (
              <>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <h4 style={{ paddingLeft: '20px', paddingTop: '10px' }}>From Date</h4>
                  <DatePicker
                    placeholderText="From Date"
                    value={
                      startDate
                        ? PivotStore.dateFormat(moment(startDate).format('MM-DD-YYYY'))
                        : ''
                    }
                    className="date-picker-style"
                    showMonthDropdown
                    showYearDropdown
                    locale="en"
                    dateFormatCalendar="MMMM"
                    yearDropdownItemNumber={15}
                    maxDate={moment().toDate()}
                    scrollableYearDropdown
                    onChange={(date: any) => setDate(date, 'start')}
                    popperProps={{ strategy: 'fixed' }}
                  />
                </div>
                <Form.Field required>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <h4 style={{ paddingTop: '10px', paddingLeft: '20px' }}>To Date</h4>
                    <DatePicker
                      placeholderText="To Date"
                      value={
                        endDate
                          ? PivotStore.dateFormat(moment(endDate).format('MM-DD-YYYY'))
                          : ''
                      }
                      className="date-picker-style"
                      showMonthDropdown
                      showYearDropdown
                      locale="en"
                      dateFormatCalendar="MMMM"
                      yearDropdownItemNumber={15}
                      maxDate={moment().toDate()}
                      scrollableYearDropdown
                      onChange={(date: any) => setDate(date, 'end')}
                      popperProps={{ strategy: 'fixed' }}
                    />
                  </div>
                </Form.Field>
                <Form.Field>
                  <Button
                    primary
                    onClick={dateBasedDataLoad}
                    style={{ paddingRight: '20px', paddingBottom: '10px' }}
                  >
                    View Report
                  </Button>
                </Form.Field>
                {loadData.length !== 0 && (
                  <div style={{ marginLeft: '5px', textAlign: 'right' }}>
                    <DynamicTableCSVReport tableData={loadData} tableName={reportName} />
                  </div>
                )}
              </>
            )}
          </div>
        </div>
        <div>
          <br />
          {isLoading ? (
            <Loader active inline="centered" size="large">
              Loading report data...
            </Loader>
          ) : (
            tableEnable && (
              <Table>
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell>Employee ID</Table.HeaderCell>
                    <Table.HeaderCell>Employee Name</Table.HeaderCell>
                    <Table.HeaderCell>Title Code</Table.HeaderCell>
                    <Table.HeaderCell>QC Frame</Table.HeaderCell>
                    <Table.HeaderCell>QC Correction Frame</Table.HeaderCell>
                    <Table.HeaderCell>FQA Frame</Table.HeaderCell>
                    <Table.HeaderCell>FQA Correction Frame</Table.HeaderCell>
                    <Table.HeaderCell>CQC Frame</Table.HeaderCell>
                    <Table.HeaderCell>CQC Correction Frame</Table.HeaderCell>
                    <Table.HeaderCell>Wave Frame</Table.HeaderCell>
                    <Table.HeaderCell>Wave Correction Frame</Table.HeaderCell>
                    <Table.HeaderCell>CC Frame</Table.HeaderCell>
                    <Table.HeaderCell>CC Correction Frame</Table.HeaderCell>
                    <Table.HeaderCell>Actual Hours</Table.HeaderCell>
                    <Table.HeaderCell>Extra Hours</Table.HeaderCell>
                    <Table.HeaderCell>Actual Framepermin</Table.HeaderCell>
                    <Table.HeaderCell>Start Date</Table.HeaderCell>
                    <Table.HeaderCell>End Date</Table.HeaderCell>
                  </Table.Row>
                </Table.Header>
                <Table.Body>
                  {loadData.length === 0 ? (
                    <Table.Row>
                      <Table.Cell colSpan={20} textAlign="center">
                        Data is currently unavailable
                      </Table.Cell>
                    </Table.Row>
                  ) : (
                    loadData.map((data, index) => (
                      <Table.Row key={index}>
                        <Table.Cell>{data.empId}</Table.Cell>
                        <Table.Cell>{data.empName}</Table.Cell>
                        <Table.Cell>{data.titleCode}</Table.Cell>
                        <Table.Cell>{data.qcFrame}</Table.Cell>
                        <Table.Cell>{data.qc_CorrectionFrame}</Table.Cell>
                        <Table.Cell>{data.fqaFrame}</Table.Cell>
                        <Table.Cell>{data.fqa_CorrectionFrame}</Table.Cell>
                        <Table.Cell>{data.cqcFrame}</Table.Cell>
                        <Table.Cell>{data.cqc_CorrectionFrame}</Table.Cell>
                        <Table.Cell>{data.waveFrame}</Table.Cell>
                        <Table.Cell>{data.wave_CorrectionFrame}</Table.Cell>
                        <Table.Cell>{data.ccFrame}</Table.Cell>
                        <Table.Cell>{data.cc_CorrectionFrame}</Table.Cell>
                        <Table.Cell>{data.actual_Hours}</Table.Cell>
                        <Table.Cell>{data.extra_Hours}</Table.Cell>
                        <Table.Cell>{data.actual_Framepermin}</Table.Cell>
                        <Table.Cell>{data.inTime}</Table.Cell>
                        <Table.Cell>{data.outTime}</Table.Cell>
                      </Table.Row>
                    ))
                  )}
                </Table.Body>
              </Table>
            )
          )}
        </div>
      </div>
    </>
  );
};

export default observer(QualityTeamTitlewisePerformace);
